module.exports = __webpack_public_path__ + "static/media/puzzle-ico.701fd840.svg";